// extracted by mini-css-extract-plugin
export default {"info__header":"styles_info__header__WuvpM","info__card":"styles_info__card__dkV+P"};